<template>
	<div class="digicoop-gcash-success">
		<app-digicoop-gcash-success-page />
	</div>
</template>

<script>

import GCashSuccessPageComponent from "@/components/GCashSuccessPage/DigicoopGCashSuccessPageComponent.vue";

export default {
	name: "GCashSuccessPageView",
	components: {
		"app-digicoop-gcash-success-page": GCashSuccessPageComponent,
	},
};
</script>